import { useCallback, useState } from "react";
import { useStore } from "@/app/store";
import type { CategoryGroup, Subcategory } from "./useCalculationDetail";

interface UseActiveBucketArgs {
  categoryGroups: CategoryGroup[];
  pageActiveCategoryId: string;
  pageActiveSubcategoryId: string;
}

const useActiveBucket = ({
  categoryGroups,
  pageActiveCategoryId,
  pageActiveSubcategoryId,
}: UseActiveBucketArgs) => {
  const categories = useStore((s) => s.calculation?.categories ?? []);

  const [selectedDimensionValue, setSelectedDimensionValue] = useState<
    string | null
  >(null);

  const resolvedCategoryId =
    pageActiveCategoryId || categoryGroups[0]?.id || "";
  const activeGroup = categoryGroups.find((g) => g.id === resolvedCategoryId);
  const resolvedSubcategoryId =
    pageActiveSubcategoryId || activeGroup?.subcategories[0]?.id || "";

  const activeCategory = categories.find(
    (c) => c.subCategoryDefinitionId === resolvedSubcategoryId,
  );
  const dimensionValues = activeCategory?.dimensionValues ?? [];
  const activeSubcategory: Subcategory = {
    id: resolvedSubcategoryId,
    name:
      activeGroup?.subcategories.find((s) => s.id === resolvedSubcategoryId)
        ?.name ??
      activeCategory?.subCategoryName ??
      "",
  };

  const activeDimensionValue =
    selectedDimensionValue && dimensionValues.includes(selectedDimensionValue)
      ? selectedDimensionValue
      : (dimensionValues[0] ?? null);

  const resetToFirstBucket = useCallback(() => {
    setSelectedDimensionValue(null);
  }, []);

  return {
    activeCategory,
    activeSubcategory,
    dimensionValues,
    activeDimensionValue,
    setActiveDimensionValue: setSelectedDimensionValue,
    setPendingActiveDimensionValue: setSelectedDimensionValue,
    resetToFirstBucket,
  };
};

export default useActiveBucket;
